import { Navigate, useParams } from 'react-router-dom';

/** Edit opens the gallery image modal on the list page. */
export default function GalleryEdit() {
  const { itemId } = useParams();
  const id = itemId ? decodeURIComponent(itemId) : '';
  if (!id) {
    return <Navigate to="/admin/dashboard/gallery" replace />;
  }
  return <Navigate to="/admin/dashboard/gallery" replace state={{ editGalleryItemId: id }} />;
}
